module.exports = __webpack_public_path__ + "img/interest.42269aad.png";